import { render } from "./Credits.vue?vue&type=template&id=098f0d1f&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=098f0d1f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-098f0d1f"

export default script